import React from 'react';
import {checkCircle} from '@sail/icons/react/Icon';
import {TerminalScreen} from 'src/v2/components/screen/TerminalScreen';
import {defineMessages, useIntl} from 'react-intl';
import {COLORS} from 'src/v2/util/color';
import {useSessionContext} from 'src/state/usePayinSessionContext';

const messages = defineMessages({
  paymentTitle: {
    id: 'crypto.payins.v2.success_screen.payment_title',
    description: 'Title for screen after successful payment',
    defaultMessage: 'Thanks for your payment',
  },
  setupTitle: {
    id: 'crypto.payins.v2.success_screen.setup_title',
    description: 'Title for screen after successful setup',
    defaultMessage: 'Your payment details are saved',
  },
});

export const SuccessScreen = () => {
  const intl = useIntl();
  const {mode} = useSessionContext();

  const titleMessage =
    mode === 'pay' ? messages.paymentTitle : messages.setupTitle;

  return (
    <TerminalScreen
      title={intl.formatMessage(titleMessage)}
      icon={checkCircle}
      iconCss={{
        color: COLORS.backgroundGreen,
      }}
      isSuccess
    />
  );
};
